import React from 'react';
import { Spinner } from 'react-bootstrap';

export default function Loader() {
  return (
    <div className='d-flex align-items-center justify-content-center'>
      <Spinner animation='border' role='status' className='loader'>
        <span className='visually-hidden'>Loading...</span>
      </Spinner>
    </div>
  )
}
